// Severity colors used across the app (MDR dashboards, Prisma Cloud), most severe first.
// Medium yellow has low contrast on white, so always show a color next to its label.
export const SEVERITIES = [
  { key: 'critical', label: 'Critical', color: '#802020' },
  { key: 'high', label: 'High', color: '#DC001E' },
  { key: 'medium', label: 'Medium', color: '#FECA00' },
  { key: 'low', label: 'Low', color: '#01AD00' }
]

const BOGOTA_OFFSET = -5 * 60 * 60 * 1000

// Bogota calendar day (YYYY-MM-DD) of a UTC epoch-ms instant
export function bogotaDay (ms) {
  return new Date(ms + BOGOTA_OFFSET).toISOString().slice(0, 10)
}
